import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import ContactFormModal from "../../Contact/ContactFormModal.jsx";
import "../../Artists/ArtistsProfile.css";
import Doknowsworldimg from "../../../imgs/artists-imgs/Doknow-pro.png";
import Doknowsworldbg from '../../../imgs/artists-imgs/doknowsworld-banner.jpg';
import { FaInstagram, FaYoutube, FaTiktok } from 'react-icons/fa';

// Prevent screen readers from focusing on the background
Modal.setAppElement('#root');


function SocialBox({ href, className, children }) {
  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={className}>
        {children}
      </a>
    );
  }
  return <div className={className}>{children}</div>;
}

function SocialCounter({ targetNumber }) {
  const [currentNumber, setCurrentNumber] = useState(0);

  useEffect(() => {
    const duration = 1500; // Duration of the animation in ms
    const intervalTime = 50; // Interval at which the number increments
    const increment = Math.ceil(targetNumber / (duration / intervalTime)); // Calculate increment per interval

    const interval = setInterval(() => {
      setCurrentNumber((prevNumber) => {
        if (prevNumber + increment >= targetNumber) {
          clearInterval(interval);
          return targetNumber; // Ensure it stops at the final number
        }
        return prevNumber + increment;
      });
    }, intervalTime);

    return () => clearInterval(interval); // Cleanup on component unmount
  }, [targetNumber]);

  return <span>{currentNumber.toLocaleString()}</span>; // Format number with commas
}

function DoknowsworldPage() {
  // Modal Setup
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [currentArtist, setCurrentArtist] = useState("");

  const openModal = (title, artistName) => {
    setModalTitle(title); // Set button text as title
    setCurrentArtist(artistName); // Set the artist's name dynamically
    setIsModalOpen(true);
  };
  const closeModal = () => setIsModalOpen(false);
  

  const [followerCounts, setFollowerCounts] = useState({
    twitter: 154000,
    facebook: 1700,
    instagram: 755000,
    youtube: 252000,
    tiktok: 1700000,
  });

  const [followerUrls, setFollowerUrls] = useState({
    facebook: "https://www.facebook.com/people/Doknows-world/61566792269695/",
    twitter: null,
    instagram: "https://www.instagram.com/doknowsworld/",
    youtube: "https://www.youtube.com/@doknowsworld",
    tiktok: "https://www.tiktok.com/@doknowsworld",
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    fetch(process.env.PUBLIC_URL + "/followers.json")
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        const entry = data && data.doknowsworld;
        if (!entry) return;
        const { urls, ...counts } = entry;
        setFollowerCounts((prev) => ({ ...prev, ...counts }));
        if (urls) setFollowerUrls((prev) => ({ ...prev, ...urls }));
      })
      .catch(() => {});
  }, []);

  const containerStyle = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.2)), url(${Doknowsworldbg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
  };


  return (
    <div className="artists-bg" style={containerStyle}>
      
    <div className="artist-detail">
      <div className="artist-left">
        <img src={Doknowsworldimg} alt="Concrete" className="artistpro-image" />
      </div>
      <div className="artist-right">
        <h1 className="artist-name">Doknowsworld</h1>

        {/* Social Media Follower Counter */}
        <div className="follower-section-compact">
          <SocialBox href={followerUrls.instagram} className="follower-box-compact instagram">
            <FaInstagram className="social-icon-compact" />
            <div className="follower-count-compact">
              <SocialCounter targetNumber={followerCounts.instagram} />
            </div>
            <div className="follower-text-compact">Followers</div>
          </SocialBox>

          <SocialBox href={followerUrls.youtube} className="follower-box-compact youtube">
            <FaYoutube className="social-icon-compact" />
            <div className="follower-count-compact">
              <SocialCounter targetNumber={followerCounts.youtube} />
            </div>
            <div className="follower-text-compact">Subscribers</div>
          </SocialBox>

          <SocialBox href={followerUrls.tiktok} className="follower-box-compact tiktok">
            <FaTiktok className="social-icon-compact" />
            <div className="follower-count-compact">
              <SocialCounter targetNumber={followerCounts.tiktok} />
            </div>
            <div className="follower-text-compact">Followers</div>
          </SocialBox>
        </div>

        {/* Buttons for Booking and Contact */}
        <div className="button-section">
        <button
          className="artist-button"
          onClick={() => openModal("Booking", "DOKNOW")}
        >
          Booking
        </button>
        <button
          className="artist-button"
          onClick={() => openModal("Contact", "DOKNOW")}
        >
          Contact
        </button>
      </div>

          {/* Modal Component */}
          <ContactFormModal
        isOpen={isModalOpen}
        onClose={closeModal}
        title={modalTitle} // Button text
        artistName={currentArtist} // Artist's name
        formAction="https://api.web3forms.com/submit" // Web3Forms API
      />

        <p className="artists-bio">
        DOKNOW IS A YOUNG COMEDIAN WHO MADE HIS RISE THROUGH INSTAGRAM/TIKTOK REELS  AND TOOK OVER THE INTERNET. 
        MOST KNOWN FOR HIS FUNNY/ CRAZY THOUGHTS ON REAL LIFE SITUATIONS, RELATIONSHIPS AND MORE. 
        HES ALSO IS PART OF BROWN BAG PODCAST, FIGGMUNITY WORLD AND MORE.
        </p>
      </div>
    </div>
    </div>

);

}

export default DoknowsworldPage;
